<template>
  <div>
    <!-- Just an image -->
    <div class="container">
      <nav class="navbar navbar-expand-lg navbar-light">
          <img src="/logo.png" width="60" height="40" class="d-inline-block align-top img-f" alt="logo" loading="lazy">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ml-auto py-4 py-md-0">
            <li class="nav-item px-lg-2 text-color">
              <router-link to="/" class="nav-link" href="#">
               <span class="d-inline-block d-sm-block d-md-none icon-width mr-2"><i class="fas fa-home"></i></span>Home</router-link>
            </li>
            <li class="nav-item px-lg-2">
              <router-link to="/login" class="nav-link"  style="">
               <span class="d-inline-block d-sm-block d-md-none icon-width mr-2"><i class="fas fa-sign-in-alt"></i></span>Sign In</router-link>
            </li>
            <li class="nav-item px-lg-2">
              <router-link to="/register" class="nav-link"  style="">
               <span class="d-inline-block d-sm-block d-md-none icon-width mr-2"><i class="fas fa-user-plus"></i></span>Register</router-link>
            </li>
          </ul>
        </div>
      </nav>

      <!-- =================Login panel====================================== -->
      <div class="row">

        <!-- first column -->
        <div class="col-sm-12 col-lg-4 d-none d-md-block mt-5 mb-12">
          <img src="/pics1.svg" alt="image" class="img-fluid mt-5"  />
        </div>
        <div class="col-sm-12 col-lg-2 d-none d-md-block mt-5 mb-12">
        </div>

        <!-- second column -->
        <div class="col-sm-12 col-lg-6">
          
          <div style="margin-top: 50px;" class="text-center">
          </div>

          <div class="text-center">
            <h6 style="font-size: 25px;" class="mt-4">Forgot Password?</h6>
          </div>

            <form style="width: 80%; margin: auto;" class="mt-6 mb-12">
                <p v-if="isError" class="red--text text-center">{{errMsg}}</p>
                <p v-if="isSuccess" class="green--text text-center">{{sucMsg}}</p>
                <p class="mt-4 text-center">Don't worry, just enter the email address you registered with and we will send you a link to reset your password</p>
                <div class="form-group mt-8">
                    <input type="email" class="form-control" id="email" placeholder="Enter your email address" 
                     required
                      v-bind:class="{'form-control' : true, 'is-invalid' : !validEmail(email) && emailBlured}"
                      v-on:blur="emailBlured = true"
                     v-model="email">
                      <div class="invalid-feedback">A valid email is required</div>
                </div>

              
                <button type="submit" :disabled="isDisabled" class="btn mt-2" style="width: 100%; background-color:#48c074; color:white" id="signIn" @click.prevent="submit($event)">Submit <span class="fa fa-circle-o-notch fa-spin" v-if="loading"></span></button>

                
            </form>


         

        </div>

        
      </div>
    </div>

  </div>
</template>

<script>
export default {
    data(){
        return{
            show1:false,
            email:'',
            emailBlured: false, 
            valid: false,
            loading: false,
            isError:false,
            isSuccess:false,
            errMsg:'',
            sucMsg:''
        }
    },
    methods:{
     validate: function(){
      this.emailBlured = true;
      if(this.validEmail(this.email)){
        this.valid = true
      }
    },
    validEmail: function(email){
      var re = /(.+)@(.+){2,}\.(.+){2,}/;
      return re.test(email.toLowerCase())
    },
    submit(event){
      event.preventDefault()
       this.validate();
       if(this.valid){
         this.loading = true
         this.$store.dispatch("ForgotPassword", {
        "email": this.email,
      
        })
        .then(()=>{
          this.sucMsg= 'A new password has been sent to your mail'
          this.isSuccess =true
          this.loading = false
        })
        .catch((error)=>{
          this.errMsg= error.response.data
          this.isError =true
          this.loading = false
        })

       }
      
    }
    
  },
  computed: {
    isDisabled: function(){
      return this.email.length == "" ;
    }
  }
}
</script>

<style scoped>
.v-application ul{
  padding: 0px;
}
 /* navigation styles */
.nav-item:after{
	position: absolute;
	bottom: -5px;
	left: 40px;
    width: 5px;
    border-radius: 50%;
	height: 5px;
    content: '';
	background-color: #48c074;
	opacity: 0;
    transition: all 200ms linear;
}
.nav-item:hover:after{
	bottom: 0;
	opacity: 1;
}
.nav-item.active:hover:after{
	opacity: 0;
}
.nav-item{
	position: relative;
    transition: all 200ms linear;
}

.navbar-toggler {
	float: right;
	border: none;
	padding-right: 0;
}
.navbar-toggler:active,
.navbar-toggler:focus {
	outline: none;
}
.navbar-light .navbar-toggler-icon {
	width: 24px;
	height: 17px;
	background-image: none;
	position: relative;
	border-bottom: 1px solid #777;
    transition: all 300ms linear;
}
.navbar-light .navbar-toggler-icon:after, 
.navbar-light .navbar-toggler-icon:before{
	width: 24px;
	position: absolute;
	height: 1px;
	background-color: #777;
	top: 0;
	left: 0;
	content: '';
	z-index: 2;
    transition: all 300ms linear;
}
.navbar-light .navbar-toggler-icon:after{
	top: 8px;
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:after {
	transform: rotate(45deg);
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:before {
	transform: translateY(8px) rotate(-45deg);
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon {
	border-color: transparent;
}
@media screen and (max-width: 768px) {
   .nav-item:after{
    visibility: hidden
  }
}
</style>